import { START_DATE } from "constants/common";
import TheBanner from "layout/TheBanner/TheBanner";
import TheFooter from "layout/TheFooter";
import TheHeader from "layout/TheHeader";
import React, { useEffect, useState } from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import { useDispatch } from "react-redux";

import routes from "routes";
import actions from "redux/home/actions";

const TheRoutes = () => {
  const dispatch = useDispatch();
  const nav = routes.map((elm) => {
    return <Route key={elm.path} path={elm.path} element={elm.element} />;
  });

  return (
    <BrowserRouter>
      <main>
        <Routes>{nav}</Routes>
      </main>
    </BrowserRouter>
  );
};

export default TheRoutes;
